module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ueditor-area"
  }, [_c('script', {
    attrs: {
      "id": "editor",
      "type": "text/plain"
    }
  }, [_vm._v(_vm._s(_vm.content))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1cf8fae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vue-ueditor.vue
// module id = 820
// module chunks = 1